import React from "react";

/**
 * "Add to LinkedIn Profile" deep-link button — official Microsoft pattern.
 * No OAuth token, no API approval needed. Opens LinkedIn's "Add License or
 * Certification" form in a new tab, pre-filled from the props you pass.
 *
 * Doc: https://learn.microsoft.com/en-us/linkedin/consumer/integrations/self-serve/add-to-profile-certifications
 */
export default function AddToLinkedInProfileButton({
  name,
  organizationName = "SkillConnect",
  organizationId,            // optional LinkedIn org id (numeric)
  issueYear,
  issueMonth,                // 1..12
  certUrl,                   // public credential URL (recommended)
  certId,                    // your internal credential number
  testId = "add-to-linkedin-btn",
  label = "Add to LinkedIn Profile",
}) {
  const params = new URLSearchParams();
  params.set("startTask", "CERTIFICATION_NAME");
  if (name) params.set("name", name);
  if (organizationName) params.set("organizationName", organizationName);
  if (organizationId) params.set("organizationId", String(organizationId));
  if (issueYear) params.set("issueYear", String(issueYear));
  if (issueMonth) params.set("issueMonth", String(issueMonth));
  if (certUrl) params.set("certUrl", certUrl);
  if (certId) params.set("certId", certId);

  const url = `https://www.linkedin.com/profile/add?${params.toString()}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className="inline-flex items-center gap-2 px-3.5 py-2 rounded-md text-sm font-semibold text-white bg-[#0A66C2] hover:bg-[#084482] transition-all duration-200 hover:-translate-y-0.5"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#ffffff" d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM.22 8.25h4.56V24H.22zM8.75 8.25h4.37v2.13h.06c.61-1.16 2.1-2.38 4.32-2.38 4.62 0 5.47 3.04 5.47 6.99V24h-4.56v-7.17c0-1.71-.03-3.92-2.39-3.92-2.39 0-2.76 1.86-2.76 3.79V24H8.75z"/>
      </svg>
      {label}
    </a>
  );
}
